<template>
    <div style="text-align: left;margin-top: 7vw;padding-left: 4vw;" class="animate__animated animate__slideInLeft">
        <div class="teamItem">
            <span class="icon groupName">
                <img class="img" src="../assets/img/teamList/c.svg" alt="">
                <img class="text" src="../assets/img/teamList/text.svg" alt="">
            </span>
            <div class="item">
                <p><img src="../assets/img/teamList/club.svg" alt=""></p>
                <span>俱乐部介绍</span>
            </div>
            <div class="item">
                <p><img src="../assets/img/teamList/exercise.svg" alt=""></p>
                <span>共享教案</span>
            </div>
        </div>
        <div v-for="(i,index) in group" :key="index" class="teamItem">
            <span class="groupName" v-if="i.groupName">
                {{ i.groupName }}
                <img class="text" src="../assets/img/teamList/text.svg" alt="">
            </span>
            <span class="icon groupName" v-else>
                <img class="img" src="../assets/img/teamList/star.svg" alt="">
                <img class="text" src="../assets/img/teamList/text.svg" alt="">
            </span>
            <div class="item" v-for="item in i.arr" :key="item.id">
                <p><img src="../assets/img/teamList/team.svg" alt=""></p>
                <span>{{ item.name[0] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "main_btn",
    computed: {
        paramsCommandFn() {
            return this.$store.state.paramsCommand;
        }
    },
    data() {
        return {
            group: [
                {
                    groupName: '',
                    arr: [
                        {
                            "id": "5f09beab2bbde45f19a055b7",
                            "name": ["一线队"],
                        }, {
                            "id": "5fbb29f499853c35e99eb2c7",
                            "name": ["U21"],
                        }
                    ]
                },
                {
                    groupName: 'W3',
                    arr: [
                        {
                            "id": "5fbb2a03fdc9d073462c41a5",
                            "name": ["U19"],
                        }, {
                            "id": "5fbb31eafdc9d073462c41a7",
                            "name": ['U17', 'u时期', '优17', '优时期'],
                        }
                    ]
                },
                {
                    groupName: 'W2',
                    arr: [
                        {
                            "id": "5fbb3207fdc9d073462c41a9",
                            "name": ["U15"],
                        }, {
                            "id": "5fbb322299853c35e99eb2c8",
                            "name": ["U14"],
                        }, {
                            "id": "5fbb322d99853c35e99eb2c9",
                            "name": ["U13"],
                        },
                    ]
                },
                {
                    groupName: 'W1',
                    arr: [
                        {
                            "id": "5fbb328e99853c35e99eb2cb",
                            "name": ["U12"],
                        }, {
                            "id": "608bbb6b4a12040ad3b8948d",
                            "name": ["U8", "优八"],
                        }
                    ]
                }
            ], //梯队分组
        }
    },
    watch: {
        paramsCommandFn: {
            handler(val, old) {
                let command = this.$aiJson.noTeam;//训练报告关键字
                let flag = 0;
                for (let p = 0; p < command.length; p++) {
                    for (let g = 0; g < command[p].identifyWord.length; g++) {//判断模块指令是否存在
                        if (eval('/' + command[p].identifyWord[g] + '/gi').test(val)) {
                            if (this.$store.state.router.name != command[p].name) {
                                this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                                clearInterval(this.$parent.timer);
                                this.$parent.imgAi(this.$imgJson.taskAiImgArr);
                                this.$store.dispatch("setRouter", {
                                    path: command[p].url,
                                    name: command[p].name,
                                    goType: 1,
                                    params: this.$route.params
                                });//vuex改变路由
                                this.$store.state.speakStr = command[p].speak;
                            }
                            flag = 1;
                            return;
                        } else {
                            flag = 0;
                        }
                    }
                }
                // console.log(flag)
                // 判断是否存在梯队
                if (!flag) {
                    for (let i = 0; i < this.group.length; i++) {
                        // console.log(this.group[i].arr)

                        for (let j = 0; j < this.group[i].arr.length; j++) {

                            // console.log(this.group[i].arr[j].name)

                            for (let k = 0; k < this.group[i].arr[j].name.length; k++) {

                                // console.log(this.group[i].arr[j].name[k])

                                if (eval('/' + this.group[i].arr[j].name[k] + '/gi').test(val)) {
                                    this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                                    this.$store.state.teamName = this.group[i].arr[j].name[k] + '_' + new Date().getTime()
                                    this.$store.state.teamId = this.group[i].arr[j].id;
                                    let routerObj = {
                                        path: '/about/main_btn',
                                        name: 'main_btn',
                                        goType: 1
                                    }
                                    this.$store.dispatch("setRouter", routerObj);//vuex改变路由
                                    flag = 1;
                                    // console.log(flag)
                                    return;
                                } else {
                                    flag = 0;
                                }
                            }

                        }
                    }
                }

                if (!flag) {
                    this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                }
            },
            deep: true
        },
    },
    mounted() {
        console.log(this.$store.state.token)
        this.$store.state.promptMsg = this.$route.meta.promptMsg;
        let userName = this.$store.state.userName;
        let userTit = this.$store.state.userTit;
        this.$parent.audioPlayFn(this.$global.audioPlayUrl(userName + this.$global.randomFn(this.$aiJson.playVoice.opening)), true, true, 2);
    },
    methods: {},
}
</script>

<style scoped lang="less">
.teamItem, .teamItem .item, .groupName {
    float: left;

}

.teamItem {
    width: 100%;
    margin-bottom: 2vw;

    .groupName {
        text-align: center;
        //width: 5vw;
        margin-left: 1.7vw;
        margin-right: 2vw;
        color: rgba(255, 255, 255, .5);
        font-family: YouSheBiaoTiHei;
        font-size: 36px;
        line-height: 3.8vw;
        border-bottom: 2.5px solid rgba(255, 255, 255, .1);
        position: relative;
        .text {
            position: absolute;
            left: -1.5vw;
            top: -.2vw;
        }
    }

    .groupName.icon {
        margin-top: .5vw;
        line-height: 3.2vw;

        img.img {
            //width: 3vw;
        }
    }

    .item {
        background-image: url("../assets/img/teamList/teamBg.svg");
        background-repeat: no-repeat;
        background-size: 100% auto;
        font-family: YouSheBiaoTiHei;
        color: #FFE900;
        font-size: 34px;
        width: calc(((100% - 7vw) / 3) - 3vw);
        padding-left: 2vw;
        margin-right: 3vw;
        line-height: 4vw;

        p, span {
            float: left;
        }

        p {
            padding-right: 1vw;
            margin-top: .5vw;

            img {
                width: 2.5vw;
            }
        }
    }
}
</style>
